/* SSi website – Portuguese landing page "Where you'll use it" vignettes. Mirrors SpanishVignettes.jsx. */

export function PortugueseVignettes({ t }) {
  const cards = [
    { tag: t.ptVigTag1, title: t.ptVigTitle1, body: t.ptVigBody1, phrase: t.ptVigPhrase1, phraseEn: t.ptVigPhraseEn1, svg: <VigPortugueseA/>, bg: '#FFE8D6' },
    { tag: t.ptVigTag2, title: t.ptVigTitle2, body: t.ptVigBody2, phrase: t.ptVigPhrase2, phraseEn: t.ptVigPhraseEn2, svg: <VigPortugueseB/>, bg: '#FFF3C4' },
    { tag: t.ptVigTag3, title: t.ptVigTitle3, body: t.ptVigBody3, phrase: t.ptVigPhrase3, phraseEn: t.ptVigPhraseEn3, svg: <VigPortugueseC/>, bg: '#FCD9D4' },
    { tag: t.ptVigTag4, title: t.ptVigTitle4, body: t.ptVigBody4, phrase: t.ptVigPhrase4, phraseEn: t.ptVigPhraseEn4, svg: <VigPortugueseD/>, bg: '#D6EADF' },
  ];

  return (
    <section className="ssi-ptVig" style={ptVigStyles.wrap}>
      <div style={ptVigStyles.inner}>
        <div style={ptVigStyles.head}>
          <div style={ptVigStyles.kicker}>{t.ptVigKicker}</div>
          <h2 style={ptVigStyles.h2}>{t.ptVigTitle}</h2>
          <p style={ptVigStyles.lede}>{t.ptVigLede}</p>
        </div>
        <ul className="ssi-ptVig__grid" style={ptVigStyles.grid}>
          {cards.map((c, i) => (
            <li key={i} style={{...ptVigStyles.card, background: c.bg}}>
              <div style={ptVigStyles.illo}>{c.svg}</div>
              <div style={ptVigStyles.tag}>{c.tag}</div>
              <h3 style={ptVigStyles.cardH}>{c.title}</h3>
              <p style={ptVigStyles.cardBody}>{c.body}</p>
              <div style={ptVigStyles.phraseBlock}>
                <div style={ptVigStyles.phrase}>&ldquo;{c.phrase}&rdquo;</div>
                <div style={ptVigStyles.phraseEn}>{c.phraseEn}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function VigPortugueseA() {
  return (
    <svg viewBox="0 0 120 80" width="100%" height="100%" fill="none">
      <ellipse cx="60" cy="58" rx="40" ry="6" fill="rgba(73,3,0,.14)"/>
      <ellipse cx="60" cy="54" rx="36" ry="8" fill="#fff" stroke="#490300" strokeWidth="1.5"/>
      <circle cx="48" cy="52" r="4" fill="#490300"/>
      <circle cx="58" cy="50" r="4" fill="#900600"/>
      <circle cx="70" cy="52" r="4" fill="#490300"/>
      <path d="M20 14 L32 14 L30 38 Q26 42 22 38 Z" fill="#DB1E17" stroke="#490300" strokeWidth="1.5"/>
      <rect x="24" y="42" width="4" height="12" fill="#490300"/>
      <ellipse cx="26" cy="54" rx="8" ry="2" fill="#490300"/>
      <ellipse cx="92" cy="34" rx="16" ry="10" fill="#FEC902" stroke="#490300" strokeWidth="1.5"/>
      <path d="M80 30 Q92 26 104 30" stroke="#490300" strokeWidth="1" fill="none"/>
    </svg>
  );
}

function VigPortugueseB() {
  return (
    <svg viewBox="0 0 120 80" width="100%" height="100%" fill="none">
      <rect x="14" y="56" width="92" height="4" fill="#490300"/>
      <rect x="20" y="60" width="3" height="14" fill="#490300"/>
      <rect x="97" y="60" width="3" height="14" fill="#490300"/>
      <circle cx="38" cy="30" r="12" fill="#FEC902" stroke="#490300" strokeWidth="1.5"/>
      <path d="M26 30 Q26 18 38 18 Q50 18 50 30 L50 26 Q50 20 38 20 Q26 20 26 26 Z" fill="#900600"/>
      <circle cx="34" cy="30" r="1.5" fill="#490300"/>
      <circle cx="42" cy="30" r="1.5" fill="#490300"/>
      <path d="M34 35 Q38 38 42 35" stroke="#490300" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      <rect x="28" y="42" width="20" height="14" fill="#DB1E17"/>
      <circle cx="82" cy="30" r="12" fill="#FFE8D6" stroke="#490300" strokeWidth="1.5"/>
      <circle cx="78" cy="30" r="1.5" fill="#490300"/>
      <circle cx="86" cy="30" r="1.5" fill="#490300"/>
      <path d="M78 35 Q82 38 86 35" stroke="#490300" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      <rect x="72" y="42" width="20" height="14" fill="#490300"/>
      <path d="M60 20 C 56 16, 52 20, 56 24 L60 28 L64 24 C 68 20, 64 16, 60 20 Z" fill="#DB1E17"/>
    </svg>
  );
}

function VigPortugueseC() {
  return (
    <svg viewBox="0 0 120 80" width="100%" height="100%" fill="none">
      <path d="M10 22 L110 22 L110 32 L10 32 Z" fill="#DB1E17"/>
      <path d="M10 22 Q20 30 30 22 Q40 30 50 22 Q60 30 70 22 Q80 30 90 22 Q100 30 110 22" stroke="#490300" strokeWidth="1.5" fill="none"/>
      <rect x="18" y="50" width="84" height="4" fill="#490300"/>
      <rect x="22" y="54" width="3" height="18" fill="#490300"/>
      <rect x="95" y="54" width="3" height="18" fill="#490300"/>
      <circle cx="36" cy="44" r="5" fill="#FEC902"/>
      <circle cx="46" cy="44" r="5" fill="#FEC902"/>
      <circle cx="56" cy="44" r="5" fill="#FEC902"/>
      <circle cx="41" cy="38" r="5" fill="#FEC902"/>
      <circle cx="51" cy="38" r="5" fill="#FEC902"/>
      <circle cx="46" cy="32" r="5" fill="#FEC902"/>
      <circle cx="76" cy="44" r="5" fill="#DB1E17"/>
      <circle cx="86" cy="44" r="5" fill="#DB1E17"/>
      <circle cx="81" cy="38" r="5" fill="#DB1E17"/>
      <rect x="66" y="38" width="6" height="10" fill="#fff" stroke="#490300" strokeWidth="1"/>
    </svg>
  );
}

function VigPortugueseD() {
  return (
    <svg viewBox="0 0 120 80" width="100%" height="100%" fill="none">
      <circle cx="92" cy="24" r="10" fill="#FEC902"/>
      <path d="M0 56 L24 32 L44 50 L68 26 L92 54 L120 38 L120 70 L0 70 Z" fill="#900600"/>
      <path d="M0 70 L30 44 L56 62 L80 40 L108 66 L120 58 L120 80 L0 80 Z" fill="#490300"/>
      <circle cx="50" cy="52" r="3" fill="#FEC902"/>
      <rect x="48" y="55" width="4" height="8" fill="#DB1E17"/>
      <rect x="46" y="63" width="3" height="5" fill="#490300"/>
      <rect x="51" y="63" width="3" height="5" fill="#490300"/>
      <line x1="54" y1="54" x2="58" y2="68" stroke="#FEC902" strokeWidth="1.5"/>
      <line x1="72" y1="40" x2="72" y2="54" stroke="#490300" strokeWidth="1"/>
      <path d="M72 40 L80 42 L72 46 Z" fill="#DB1E17"/>
    </svg>
  );
}

const ptVigStyles = {
  wrap: { background: 'var(--bg-2, #fff)', padding: '96px 32px 96px' },
  inner: { maxWidth: 1240, margin: '0 auto' },
  head: { maxWidth: 760, marginBottom: 56 },
  kicker: { fontSize: 12, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--brandRed)', fontWeight: 700, marginBottom: 14 },
  h2: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1.08, letterSpacing: '-.015em', margin: '0 0 18px' },
  lede: { fontFamily: 'var(--font-body)', fontSize: 18, lineHeight: 1.55, color: 'var(--grey)', margin: 0, textWrap: 'pretty', maxWidth: '60ch' },
  grid: { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 22 },
  card: { border: '1px solid rgba(73,3,0,.12)', borderRadius: 18, padding: '22px 22px 24px', display: 'flex', flexDirection: 'column', gap: 10, boxShadow: '0 10px 24px -18px rgba(73,3,0,.35)' },
  illo: { background: '#fff', borderRadius: 12, border: '1px solid rgba(73,3,0,.12)', padding: 10, marginBottom: 6, aspectRatio: '3 / 2', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  tag: { display: 'inline-block', alignSelf: 'flex-start', fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--brandRed)', background: '#fff', padding: '4px 10px', borderRadius: 999, border: '1px solid rgba(73,3,0,.14)' },
  cardH: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, lineHeight: 1.2, margin: '4px 0 2px', color: 'var(--fg-1)', letterSpacing: '-.005em' },
  cardBody: { fontFamily: 'var(--font-body)', fontSize: 14, lineHeight: 1.5, color: 'var(--fg-1)', margin: 0, textWrap: 'pretty' },
  phraseBlock: { marginTop: 'auto', paddingTop: 14, borderTop: '1px dashed rgba(73,3,0,.3)' },
  phrase: { fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 16, color: 'var(--deepRed)', lineHeight: 1.35, marginBottom: 2 },
  phraseEn: { fontFamily: 'var(--font-body)', fontSize: 12, color: 'var(--grey)', fontStyle: 'italic' },
};
